export const OnboardingCategories = [
    {label: "General", value: 'general'},
    {label: "ISDA", value: 'isda'},
]

export const OnboardingTier = [
    {label: "1", value: 'one'},
    {label: "2", value: 'two'},
    {label: "3", value: 'three'},
]